import store from '@shared/store/index';
import { useAudioPlayerState } from './computedValues';

const { podcast, isPlaying, isAnyLoading } = useAudioPlayerState();

const toggleAudio = (idPodcast) => {
  const isTheSamePodcast = podcast.value?.id == idPodcast;
  if(isPlaying.value && isTheSamePodcast){ 
    store.dispatch('Audioplayer/pauseAudio');
  } else if(isTheSamePodcast){
    store.dispatch('Audioplayer/resumeAudio');
  } else{
    store.dispatch('Audioplayer/playAudio', { id: idPodcast });
  }
};

/**
 * Перемещает воспроизведение к указанному времени
 * @param {number} time - Время в секундах
 * @param {string|number} [idPodcast] - ID подкаста (опционально)
 */
const seekToTime = async (time, idPodcast) => {
  if (isAnyLoading.value) return;
  if (idPodcast && podcast.value?.id !== idPodcast) {
    await store.dispatch('Audioplayer/playAudio', { id: idPodcast });
  } 
  const safeTime = Math.max(0, Math.min(time, podcast.value?.audio_length || 0));
  await store.dispatch('Audioplayer/resumeAudio', safeTime);
};

export function useAudioControl() {
  return {
    toggleAudio,
    seekToTime
  };
}
